import axios from 'axios'
import store from '@/state/store'

axios.defaults.baseURL = process.env.VUE_APP_CADASTRO_API

axios.interceptors.request.use(async function (request) {
    return request
}, function (error) {
    return Promise.reject(error);
})

axios.interceptors.response.use(async function (response) {
    return response
}, function (error) {
    if (error.response) {
        switch (error.response.status) {
            case 409:
                localStorage.clear()
                location.reload()
                break;
            case 401:
                if (location.pathname !== '/login') {
                    store.dispatch('keycloak/signOut')
                    location.href = '/login'
                }
                // if (localStorage.getItem('token')) {
                //     store.dispatch('keycloak/getRefreshToken').then(() => {
                //         error.config.headers['Authorization'] = 'Bearer ' + store.state.keycloak.token;
                //         return axios.request(error.config);
                //     })
                // }
                break;
        }
    }
    return Promise.reject(error)
})